import { render, staticRenderFns } from "./TorchControl.vue?vue&type=template&id=2a89b2ce&scoped=true&"
import script from "./TorchControl.vue?vue&type=script&lang=js&"
export * from "./TorchControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a89b2ce",
  null
  
)

export default component.exports